export default __webpack_public_path__ + "static/media/youtube.0805ec08.svg";